var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticClass: "table is-shadowless is-fullwidth is-hoverable" },
    [
      _c("thead", [
        _c("tr", { staticClass: "has-text-centered" }, [
          _c(
            "th",
            {
              staticStyle: { "vertical-align": "bottom", width: "15%" },
              attrs: { rowspan: "2" }
            },
            [_vm._v("Asignatura")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticStyle: { "vertical-align": "bottom", width: "45%" },
              attrs: { rowspan: "2" }
            },
            [_vm._v("Nombre")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticClass: "has-text-centered",
              staticStyle: { border: "none" },
              attrs: { colspan: _vm.snapshots }
            },
            [_vm._v("Corte")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticStyle: { "vertical-align": "bottom" },
              attrs: { rowspan: "2" }
            },
            [_vm._v("Final")]
          ),
          _vm._v(" "),
          _c(
            "th",
            {
              staticStyle: { "vertical-align": "bottom" },
              attrs: { rowspan: "2" }
            },
            [_vm._v("Estado")]
          )
        ]),
        _vm._v(" "),
        _c(
          "tr",
          { staticClass: "has-text-left" },
          _vm._l(_vm.snapshots, function(n) {
            return _c("th", [_vm._v(_vm._s(n))])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.collapsed.length > 0
        ? _c(
            "tbody",
            _vm._l(_vm.collapsed, function(g) {
              return _c(
                "tr",
                { class: { disabled: g.disabled } },
                [
                  _c("td", [_vm._v(_vm._s(g.courseCode))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(g.courseName))]),
                  _vm._v(" "),
                  _vm._l(_vm.snapshots, function(s) {
                    return _c(
                      "td",
                      {
                        class:
                          g.snapshots[s - 1] < _vm.gradeThreshold && "deficient"
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(g.snapshots[s - 1]) + "\n      "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    { class: g.final < _vm.gradeThreshold && "deficient" },
                    [_vm._v(_vm._s(g.final))]
                  ),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(g.status))])
                ],
                2
              )
            }),
            0
          )
        : _c("tbody", [
            _c("tr", [
              _c("td", { attrs: { colspan: 6 } }, [
                _vm._v("Sin registro de notas para este periodo")
              ])
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }